// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"5048":"f4265a3d","8097":"c09e0ea4"}[chunkId] + ".css";
};